import type { IBottomNavigationContainerProps } from '../../types/index'
import * as Comp from './bottom-container.styles'

export const BottomNavigationContainer = ({
  children,
}: IBottomNavigationContainerProps) => {
  return <Comp.Container>{children}</Comp.Container>
}
